import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../stores/useAuthStore';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: 'admin' | 'proctor' | 'testTaker' | 'faculty';
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const authStore = useAuthStore();
  const location = useLocation();

  // If not authenticated, redirect to login
  if (!authStore.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If a specific role is required, check if user has that role
  if (requiredRole && authStore.user?.role !== requiredRole) {
    // Redirect to appropriate dashboard based on user's actual role
    const userRole = authStore.user?.role;
    if (userRole) {
      switch (userRole) {
        case 'admin':
          return <Navigate to="/admin" replace />;
        case 'proctor':
          return <Navigate to="/proctor" replace />;
        case 'testTaker':
          return <Navigate to="/test-taker" replace />;
        case 'faculty':
          return <Navigate to="/faculty" replace />;
        default:
          return <Navigate to="/login" replace />;
      }
    }
  }

  // User is authenticated and has the required role (if specified)
  return <>{children}</>;
};

export default ProtectedRoute;
